import vmClient from 'app/services/vmClient';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';
import { ALL_TRANSLATIONS, TranslationsForEntity } from './translations';

export interface IBlockedEmailDomain extends IEntity {
  attributes: {
    id: EntityStringId;
    name: string;
  };
}

export type BlockedEmailDomain = Entity<IBlockedEmailDomain>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BlockedEmailDomain: IEntityType<IBlockedEmailDomain> = vmClient.defineClass({
  typeName: 'BlockedEmailDomain',
  version: 1,
  persisted: true,
  attributes: {
    name: {
      type: 'string',
      notNull: true,
    },
  },
});

export const BlockedEmailDomainFieldTranslations: Partial<TranslationsForEntity<IBlockedEmailDomain>> = {
  id: {
    getLabel: (t) => t('entity-fields.BlockedEmailDomain.id.label'),
  },
  name: {
    getLabel: (t) => t('entity-fields.BlockedEmailDomain.name.label'),
  },
};

ALL_TRANSLATIONS.set(BlockedEmailDomain, BlockedEmailDomainFieldTranslations);
